import { NotificationDocument } from '@models/notification';
import { NotificationItem } from './NotificationItem';
import { BellRingIcon } from './BellRingIcon';

const NotificationList = ({
  groupedNotifications,
  areNotificationsEmpty,
  activeFilter,
}: {
  groupedNotifications: {
    today: NotificationDocument[];
    yesterday: NotificationDocument[];
    lastWeek: NotificationDocument[];
    lastMonth: NotificationDocument[];
  };
  areNotificationsEmpty: boolean;
  activeFilter: string;
}) => {
  if (areNotificationsEmpty) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <div className="flex flex-col items-center gap-8">
          <BellRingIcon className="h-32 w-32 opacity-60" />

          <span className="text-[1.8rem] font-medium text-zinc-500">
            You have no new notifications
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-full w-full flex-col gap-[1.6rem] overflow-y-auto pb-[18rem]">
      {groupedNotifications.today.length > 0 && (
        <NotificationSection
          title="Today"
          key="today"
          notifications={groupedNotifications.today}
        />
      )}

      {groupedNotifications.yesterday.length > 0 && (
        <NotificationSection
          title="Yesterday"
          key="yesterday"
          notifications={groupedNotifications.yesterday}
        />
      )}

      {groupedNotifications.lastWeek.length > 0 && (
        <NotificationSection
          title="Last Week"
          key="last-week"
          notifications={groupedNotifications.lastWeek}
        />
      )}

      {groupedNotifications.lastMonth.length > 0 && (
        <NotificationSection
          title="Last Month"
          key="last-month"
          notifications={groupedNotifications.lastMonth}
        />
      )}
    </div>
  );
};

function NotificationSection({
  title,
  notifications,
}: {
  title: string;
  notifications: NotificationDocument[];
}) {
  const hasUnreadMessages = notifications.some(
    (notification) => !notification.read
  );

  return (
    <div className="flex flex-col gap-[1.6rem]">
      <span className="px-4 text-[1.6rem] font-medium uppercase tracking-tight text-zinc-400">
        {title}
      </span>

      <div className="flex flex-col gap-y-8">
        {notifications.map((notification) => (
          <NotificationItem
            key={notification.id}
            notification={notification}
            hasUnreadMessages={hasUnreadMessages}
          />
        ))}
      </div>
    </div>
  );
}

export { NotificationList };
